import styled from 'styled-components'
import { ProductCard } from '@sainsburys-tech/bolt'

const M010ProductCard = styled(ProductCard)`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.theme.color.monochrome.white};
`

export { M010ProductCard }
